/** Public visibility does not imply that a catalog is a generic framework. */
export const isReviewedTextbook=(book:any)=>book?.status==='verified'&&book?.provenance?.dataset==='suzhou-textbook-2026-2027';
export const isTeachingFramework=(book:any)=>book?.status==='framework';
export const sortCurriculumBooks=(books:any[])=>[...books].sort((a,b)=>Number(isReviewedTextbook(b))-Number(isReviewedTextbook(a)));

/** A volume/module choice must stay explicit when multiple real books match. */
export function defaultSelectionBook(books:any[]){
  const reviewed=books.filter(isReviewedTextbook);
  if(reviewed.length)return reviewed.length===1?reviewed[0]:undefined;
  return books.length===1?books[0]:books.find(book=>book.provenance?.systemCatalog);
}
